import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Glyph from 'component/utils/Glyph'

const FIELDS = ['advancedField']

const AdvancedFilter = ({ fields, onSubmit, translate, values }) => {
  const beforeOnSubmit = (event) => {
    event.preventDefault()

    // Remove apenas caracteres especiais, mantendo letras e números
    const sanitizedValue = values.advancedField 
      ? values.advancedField.replace(/[^a-zA-Z0-9]/g, '').trim()
      : ''

    onSubmit({ advancedField: sanitizedValue })
  }

  return (
    <div>
      <form onSubmit={beforeOnSubmit}>
        <div className='tracking-monitor-fieldset-wrapper'>
          <div className='tracking-monitor-field-wrapper'>
            <Field {...fields.advancedField}>
              <Input
                {...fields.advancedField.input}
                bottomLabel={translate(
                  'totem.trackingMonitor.advancedFilter.field.advancedField.label'
                )}
                label={translate(
                  'totem.trackingMonitor.advancedFilter.field.advancedField'
                )}
                maxLength={25}
              />
            </Field>
          </div>
          <div className='tracking-monitor-field-wrapper'>
            <button className='button button-primary button-full'>
              <Glyph color='neutral' type='magnifier' />
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default Form({ fields: FIELDS })(AdvancedFilter)

AdvancedFilter.propTypes = {
  fields: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}
